<div class="big-screen">
  <a *ngFor="let item of navigationItems" [routerLink]="'/' + item.link" class="nav__button__container">
    <div class="nav__button" [ngClass]="{'nav__button--active': currentPage.link === item.link}">
      <div class="nav__button-text">{{ item.title |translate }}</div>
    </div>
  </a>
</div>
<!--<div class="small-screen">
  <div class="nav__button nav__button--active" (click)="toggleNavOptions()">
    <div class="nav__button-text">{{ currentPage.title |translate }} &#9662;</div>
  </div>
  <div class="nav__button--options" [ngClass]="{'show': showNavOptions}">
    <a *ngFor="let item of navigationItems" [routerLink]="'/' + item.link" (click)="toggleNavOptions()">
      <div class="nav__button" [ngClass]="{'nav__button--active': currentPage.link === item.link}">
        <div class="nav__button-text">{{ item.title |translate }}</div>
      </div>
    </a>
  </div>
</div>-->



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/components/navigation/navigation.component.html